import { useCurrentEntityId } from "./useCurrentEntityId";
import { useCurrentGroupContext } from "./useCurrentGroupContext";

export const useCurrentEntity = () => {
  const entityId = useCurrentEntityId();
  const { entities, secondary_channel_url } = useCurrentGroupContext();

  const currentEntity = entities.find((entity) => entity.uuid === entityId);

  return {
    ...(currentEntity || {}),
    bookkeeping_channel:
      currentEntity?.bookkeeping_channel || secondary_channel_url,
  };
};
